import React, { useState } from 'react'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { blueColour, goldColour } from '../pages/Home'
import { FaHome } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
const BlueButton = ({
  children,
  fn=() => {},
  navigateTo,
  hide,
  text="Test Button",
  margins=true,
  textColour='white',
  textHoverColour='white',
  color = blueColour,
  hoverColor = goldColour,
  disabled,
  buttonStyle={},
  style={},
  home
  
}) => {
  
  const [isHovered, setIsHovered] = useState(false)
  const buttonMargins = margins ? {margin: "10px"} : {}
  
  const navigate = useNavigate();
        
  const backToHome = () => {
    window.scrollTo(0, 0);
    navigate('/');
    }

  const defaultStyle = {
    //background: color,
    //color: textColour,
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'background-color 0.3s',
    opacity: disabled ? 0.7 : 1,
    ...buttonStyle
  }

  const currentStyle = {
    ...defaultStyle,
    color: isHovered ? (textHoverColour) : (textColour),
    background: isHovered ? (hoverColor) : (color)
  }
  if (home) {
    return (
      <div onClick={backToHome} style={{...buttonMargins, ...style, cursor: 'pointer'}}>
        <FaHome size={30}/>
      </div>
    )
  }

  return (
    <VisDiv style={{...buttonMargins, ...style}} rules={[!hide]}>
      <button
        disabled={disabled}
        onClick={()=>{
          fn()
          navigateTo && navigate(navigateTo)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={currentStyle}

      >
        {text}
        {children}
      </button>
    </VisDiv>
  )
}

export default BlueButton
